// UI constants for consistent styling and responsive design

export const ALLOCATION_BAR = {
  DEFAULT_WIDTH: 60,
  DEFAULT_HEIGHT: 3,
  MOBILE_WIDTH: 50,
  MIN_FILL_WIDTH: 2,
} as const;

export const BREAKPOINTS = {
  MOBILE_MAX: 359,
  SMALL_PHONE: 375, // Hide middle column below this width (older phones like iPhone SE)
} as const;

export const INVESTMENT_TABLE = {
  MIN_TABLE_WIDTH: 320,
  ROW_HEIGHT: 56,
  BOOKMARK_COLUMN_WIDTH: 25,
} as const;
